import React from "react";
import { Dialog, DialogContent, DialogActions } from "@mui/material";
import { styled } from "@mui/material/styles";
import Button from "../../../component-lib/Molecules/button/Button";
import CloseIcon from "@mui/icons-material/Close";
import Heading from "../../../component-lib/Atoms/heading/EventEHRHeading";
import { TEXT_CONSTANTS } from "../../../utils/text-constants/textConstants";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: "16px 24px",
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
  "& .MuiPaper-root": {
    BorderAllRounded: "8px",
    Height: "436px",
    width: "850px", // Set your custom width here
    maxWidth: "none", // Prevents Material-UI from overriding your width
  },
}));

interface ViewInventoryDialogProps {
  isOpen: boolean;
  dialogHeading: string;
  handleClose: () => void;
  inventoryData: any;
}

const ViewInventoryDialog = ({
  isOpen = false,
  inventoryData,
  handleClose,
  dialogHeading = "Your Heading Here...",
}: ViewInventoryDialogProps) => {
  return (
    <React.Fragment>
      <BootstrapDialog
        onClose={(event, reason) => {
          if (reason !== "backdropClick") {
            handleClose();
          }
        }}
        aria-labelledby="customized-dialog-title"
        open={isOpen}
      >
        <div
          className="flex justify-between items-center rounded-lg"
          style={{ margin: "14px 24px" }}
        >
          <Heading title={dialogHeading} />
          <div onClick={handleClose} className="cursor-pointer">
            <CloseIcon />
          </div>
        </div>

        <DialogContent dividers>
          {inventoryData ? (
            <div
              style={{
                padding: "24px 16PX",
                display: "grid",
                gap: "24px 16px",
                gridTemplateColumns: "1fr 1fr",
                border: "1px solid #E8E8E8",
              }}
            >
              <p>
                <strong>Item Name: </strong>
                {inventoryData?.itemName}
              </p>
              <p>
                <strong>Item Id: </strong>
                {inventoryData?.itemID}
              </p>

              <p>
                <strong>Type: </strong> {inventoryData?.category || ""}
              </p>
              <p>
                <strong>Unit Of Measure: </strong>{" "}
                {inventoryData?.unitOfMeasure || ""}
              </p>
              <p>
                <strong>Quantity:</strong> {inventoryData?.currentStock || ""}
              </p>
              <p>
                <strong>Stock Keeping Unit:</strong>{" "}
                {inventoryData?.stockKeepingUnit || "-"}
              </p>

              <p>
                <strong>Threshold Value:</strong>{" "}
                {inventoryData?.reorderPoint || ""}
              </p>
              <p>
                <strong>Supplier/Vendor Name:</strong>{" "}
                {inventoryData?.supplierName || "-"}
              </p>

              <p>
                <strong>Purchase Price/Unit:</strong>{" "}
                {inventoryData?.purchaseUnit || ""}
              </p>
              <p>
                <strong>Batch Number:</strong>{" "}
                {inventoryData?.batchNumber || "-"}
              </p>
            </div>
          ) : (
            <p>No task data available</p>
          )}
        </DialogContent>
        <DialogActions>
          <div className="p-2">
            <Button
              // disabled={!isValid} // Button disabled if form is invalid or submitting
              label={TEXT_CONSTANTS?.CLOSE}
              variant="contained"
              onClickCb={handleClose}
              style={{
                width: "120px",
                height: "44px",
                padding: "12px 20px",
                fontSize: "16px",
                marginRight: "6px",
              }}
            ></Button>
          </div>
        </DialogActions>
      </BootstrapDialog>
    </React.Fragment>
  );
};

export default ViewInventoryDialog;
